import { useEffect, useState } from "react";
import { CaseServices } from "../services/CaseServices";
import CloseIcon from "../assets/crossIcon.svg";
import { CircularProgress } from "@mui/material";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import PdfIcon from "../assets/pdfIcon.png";
import downloadPdf from "../utils/downloadPdfUtil";
import downloadIcon from "../assets/downloadIconGreen.svg";
import { AuthServices } from "../services/AuthServices";
import { RpaServices } from "../services/RpaServices";
import { fetchNewCaseNotificationCount } from "../redux/notificationSlice";
import { useDispatch } from "react-redux";
const DownloadDocumentsForRpa = ({ setOpen, selectedRpaLog, fetchrpaLogs }) => {
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [downloading, setDownloading] = useState(-1);
  const [documents, setDocuments] = useState(null);
  const [currentStage, setCurrentStage] = useState("");
  const [percentage, setPercentage] = useState(0);
  const [netSpeed, setNetSpeed] = useState(0);
  const dispatch = useDispatch();
  const generatePDFUsingPython = async (
    images,
    compression,
    documentName,
    idx
  ) => {
    setDownloading(idx);
    const selectedImages = images.filter(
      (image) => image.status === "READYFORRPA"
    );
    const imagesUrl = selectedImages.map((image) => ({
      image: image.documentUrl,
      compressionPossible: compression,
    }));
    if (imagesUrl.length < 1) {
      window.alert("Please set atleast one image status to ready for rpa");
      setDownloading(-1);
      return;
    }
    try {
      const targetSize = selectedRpaLog?.pmjayCaseId ? 500 : 1024;
      let response = await AuthServices.loadImagesBase64UsingPython(
        { images: imagesUrl },
        setPercentage,
        setNetSpeed,
        targetSize
      );
      downloadPdf(response.data, documentName);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setDownloading(-1);
  };
  const handleRpaRequestStatus = async () => {
    const data = {
      requestId: selectedRpaLog?.id,
      requestStatus: "COMPLETED",
      oldStatus: selectedRpaLog?.requestStatus,
      statusRemark: "Manually Updated",
    };

    try {
      const response = await RpaServices.updateRpaRequest(data);
      if (response?.status === 200) {
        alert("Changes saved successfully!");
        dispatch(fetchNewCaseNotificationCount());

        setOpen(false);
      } else {
        alert("Failed to update rpa details.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const handleInitiateOnTMS = async () => {
    setSubmitting(true);
    if (
      currentStage[0]?.commandCenterStage ===
        "Admission Documents Approved by Team C" ||
      currentStage[0]?.commandCenterStage ===
        "Enhancement  Documents  Approved by Team E" ||
      currentStage[0]?.commandCenterStage ===
        "Claim Documents  Approved by Team E"
    ) {
      const postStageData = {
        hsaStage: currentStage[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("admission")
          ? "Admission Initiated on TMS"
          : currentStage[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("enhancement")
          ? "Enhancement Initiated on TMS"
          : currentStage[0]?.commandCenterStage?.toLowerCase().includes("claim")
          ? "Claim Initiated on TMS"
          : "",
        commandCeneterStage: currentStage[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("admission")
          ? "Admission Initiated on TMS"
          : currentStage[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("enhancement")
          ? "Enhancement Initiated on TMS"
          : currentStage[0]?.commandCenterStage?.toLowerCase().includes("claim")
          ? "Claim Initiated on TMS"
          : "",
        nextStepUser: currentStage[0]?.commandCenterStage
          ?.toLowerCase()
          .includes("admission")
          ? "Internal team C"
          : currentStage[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("enhancement")
          ? "Internal Team E"
          : currentStage[0]?.commandCenterStage?.toLowerCase().includes("claim")
          ? "Internal Team E"
          : "",
        caseDetails: [
          {
            query: "",
            queryResponse: "",
          },
        ],
      };
      try {
        if (selectedRpaLog?.pmjayId) {
          await RpaServices.addRpaRequest({
            hospitalId: selectedRpaLog.hospitalId,
            caseStatus: "STATUS_UPDATE",
            requestType: currentStage[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("claim")
              ? "CLAIM"
              : "PREAUTH",
            caseId: selectedRpaLog.caseId,
            pmjayCaseId: selectedRpaLog?.pmjayId,
          });
          const stageResponse = await CaseServices.updateSubMasterStage(
            selectedRpaLog.caseId,
            postStageData
          );
          window.alert(stageResponse.data.message);
        } else {
          await RpaServices.addRpaRequest({
            hospitalId: selectedRpaLog.hospitalId,
            caseStatus: "STATUS_UPDATE",
            requestType: currentStage[0]?.commandCenterStage
              ?.toLowerCase()
              .includes("claim")
              ? "CLAIM"
              : "PREAUTH",
            caseId: selectedRpaLog.caseId,
            pmjayRegistrationId: selectedRpaLog?.pmjayRegistrationId,
          });
          const stageResponse = await CaseServices.updateSubMasterStage(
            selectedRpaLog.caseId,
            postStageData
          );
          window.alert(stageResponse.data.message);

          if (stageResponse.data.message === "Case stage updated") {
            setOpen(false);
          }
        }
        await handleRpaRequestStatus();
        await fetchrpaLogs("Pending");
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      window.alert("The case has already been moved to the next stage.");
    }

    setSubmitting(false);
  };
  const getLatestCaseStage = async () => {
    setLoading(true);
    try {
      const response = await CaseServices.getLatestCaseStage(
        selectedRpaLog?.caseId
      );

      console.log("response data:", response?.data);
      setCurrentStage(response?.data?.currnetSubMasterStage);
      setDocuments(response.data.documents);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    getLatestCaseStage();

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-screen h-screen  flex justify-center items-center bg-[#017C5780] z-[1210]">
      <div className="relative w-[80%] h-[80%] bg-white rounded-[20px] p-10">
        {" "}
        <div
          className="absolute top-4 right-5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <img src={CloseIcon} alt="close-icon" />
        </div>
        <div className="flex justify-between items-center">
          <div className="font-semibold text-xl mb-4">Uploaded Documents</div>
          {submitting ? (
            <CircularProgress />
          ) : (
            <div
              className="text-sm font-semibold text-white bg-[#017C57] px-8 py-3 rounded-full cursor-pointer"
              onClick={handleInitiateOnTMS}
            >
              Documents Uploaded on Tms
            </div>
          )}
        </div>
        <div className="h-[80%] overflow-auto">
          {loading ? (
            <div className="h-full flex justify-center items-center">
              {" "}
              <CircularProgress />
            </div>
          ) : (
            <div className="flex gap-4 flex-wrap">
              {documents?.map((doc, idx) => {
                return (
                  <div
                    key={idx}
                    style={{ border: "1px solid #E4E4E4" }}
                    className={`relative rounded-[17px] p-1 bg-white`}
                  >
                    {" "}
                    <img
                      src={PdfIcon}
                      alt=""
                      width={248}
                      height={249}
                      style={{ border: "1px solid #E4E4E4" }}
                      className="object-fit rounded-[15px]"
                    />
                    <div
                      className="absolute top-3 right-3 cursor-pointer"
                      onClick={() =>
                        generatePDFUsingPython(
                          doc?.documenturlmasters,
                          true,
                          doc?.documentName,
                          idx
                        )
                      }
                    >
                      {downloading === idx ? (
                        <CircularProgress />
                      ) : (
                        <img src={downloadIcon} alt="download-icon" />
                      )}
                    </div>
                    <div className="absolute bottom-0.5 left-0  w-full ">
                      <div
                        style={{
                          background: "#00000060",
                          backdropFilter: "blur(3.6976048946380615px)",
                        }}
                        className="flex w-[94%] justify-between items-center rounded-[14px] py-2 mx-auto px-1"
                      >
                        <div className="text-sm text-white leading-[18.27px] -tracking-[3%] text-ellipsis whitespace-nowrap overflow-hidden">
                          {doc?.documentName}
                        </div>
                        <div className="text-white text-sm mr-2">
                          {doc?.documenturlmasters && (
                            <div>{doc?.documenturlmasters?.length}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DownloadDocumentsForRpa;
